export default {
  unread: '未读',
  read: '已读',
  today: '今日',
  all: '全部',
  send: '发送',
  inputTipStart: '您已输入',
  inputTipEnd: '个字符, 应少于600个字符',
  orderId: '订单ID: ',
  orderNo: '订单编号: ',
  paymentTime: '下单时间: ',
  orderAmount: '订单金额: ',
  noSldMsg: '请选择聊天会话',

  search: '搜索',
  noData: '暂无数据',
  uploadTips: '图片/视频',
  orderLabel: '订单',
  product: '商品',
  voucher: '店铺券',
  maxSizeErr: '视频最大为20M, 图片最大为2M',
  cmdEnter: '(Cmd+Enter)',
  ctrlEnter: '(Ctrl+Enter)'
}
